require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-loyalty-rewards.json") })
        }
      }, "path---es-articles-tags-loyalty-rewards");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-loyalty-rewards!./.cache/json/es-articles-tags-loyalty-rewards.json
// module id = 2331
// module chunks = 231608221292675